const initialState = {
  createArticle: false,
  firstPage: false,
  message: "",
  authenticated: false,
  userEmail: "",
  loginForm: true
};

export default initialState;
